import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import CheckIcon from "@mui/icons-material/Check";

function UseQsButton({ Qs, handleSetQs }) {
  const isQsInvalid = isNaN(Qs) || Qs === undefined || Qs === 0;

  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 13) {
        if (!isQsInvalid) {
          handleSetQs(Qs);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [Qs, isQsInvalid, handleSetQs]);


  
 


  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
        border: "2px solid green",
        borderRadius: 1,
        padding: 2,
      }}
    >



      <div sx={{ width: "50%" }}>
        <Typography variant="h6">
          ΣQs: {Number(Qs) ? parseFloat(Qs).toFixed(2) : Qs} L/s
        </Typography>
      </div>
      <Button
        variant="contained"
        disabled={isQsInvalid}
        onClick={() => handleSetQs(Qs)}
        sx={{
          bgcolor: "green",
          color: "white",
          width: "50%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ":hover": { bgcolor: "darkgreen" },
        }}
      >
        Bruk denne vannføringen
        <CheckIcon />
      </Button>
    </Box>
  );
}

export default UseQsButton;
